module.exports = __webpack_public_path__ + "images/right.35c6c84de715af090c5b74767413b91b.png";